export default "__VITE_ASSET__DIsN_Ea4__"